const $contactMarketToggleSelect = $('.js-login-block__market__select');

const changePageOnSelectChange = (e) => { 
    const url = e.currentTarget.value;
    window.location = url;
};

const events = () => {
    $contactMarketToggleSelect.on('change', changePageOnSelectChange);
}

const init = () => {
    events();
}

export default init;
